import SocialIconGroup from '@/components/organisms/SocialIconGroup';
import React from 'react';

export const FollowBlog: React.FC = () => (
  <section className="flex flex-col gap-xl md:flex-row md:justify-center">
    <h3 className="text-h3SemiBold">
      Follow EV.com for all the latest news and events
    </h3>
    <div className="flex flex-row justify-between gap-l md:justify-start">
      <SocialIconGroup keyPrefix="news-social-media-section" />
    </div>
  </section>
);
